import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {SubventionPreference} from '../model/subvention-preference.model';
import {Injectable} from '@angular/core';

@Injectable()
export class SubventionPreferenceService {
    private httpClient: HttpClient;
    private configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }


    public async get(partnerId: string): Promise<SubventionPreference> {
        return await this.httpClient.get<SubventionPreference>(`${this.configService.baseUrl()}subvention-preference?partnerId=${partnerId}`).toPromise();
    }
}
